import { Card } from "@forge/common";
import totalCourses from '../../../../../common/assets/total-courses.svg';
import publishedCourses from '../../../../../common/assets/published-courses.svg';
import publishedCoursesDark from '../../../../../common/assets/published-dark.svg';
import draftDarkImg from '../../../../../common/assets/draft-dark.svg';
import totalCoursesDarkImg from '../../../../../common/assets/total-courses-dark.svg';
import courseInstanceDarkImg from '../../../../../common/assets/course-instance-dark.svg';
import courseInstanceImg from '../../../../../common/assets/course-instance.svg';
import draftImg from '../../../../../common/assets/draft.svg';
import "./view-course-count-card.scss";
import { getResponsiveFontSize, textResponsive } from "../../common/utils/helper";

const cardData = [
  {
    id: 2,
    title: "DRAFT",
    icon: draftImg,
    iconSelected: draftDarkImg,
  },
   {
    id: 1,
    title: "PUBLISHED",
    icon: publishedCourses,
    iconSelected: publishedCoursesDark,
  },
  {
    id: 0,
    title: "COURSE ENVIRONMENTS",
    icon: totalCourses,
    iconSelected: totalCoursesDarkImg,
  },
  {
    id: 3,
    title: "DEPLOYED COURSES",
    icon: courseInstanceImg,
    iconSelected: courseInstanceDarkImg,
  }
];

const ViewCourseCount = (props: any) => {
  const mergedCardData = cardData.map(card => {
    const countObj = props.cardCourseCountData?.find((c: any) => Number(c.id) === card.id);
    return {
      ...card,
      count: countObj ? countObj.count : 0,
    };
  });

  return (
    <div className="view-course-list py-1">
      <Card className="parent-card-course !p-3 !rounded-none w-full">
        <div className="card-row flex flex-nowrap gap-2">
          {mergedCardData.map((card) => (
            <Card
              key={card.title}
              role="button"
              tabIndex={0}
              data-testid={`card-courses-${card.id}`}
              className={
                `card-courses` +
                (props.selectedCard === card.id ? " selected" : "") +
                " !min-h-[74px] xl-high:!min-h-[86px] !h-auto !rounded-none shadow-none flex justify-between items-start !p-[10px] xl-high:!p-[12px] cursor-pointer flex-1 basis-0 min-w-0"
              }
              onClick={() => props.setSelectedCard(card?.id)}
            >
              <div className="min-w-0 pr-1">
                <div
                  className={
                    `count-courses` +
                    (props.selectedCard === card.id ? " selected" : "") +
                    ` ${getResponsiveFontSize(28)} font-bold leading-[1.05] xl-high:mb-1`
                  }
                >
                  {card.count}
                </div>
                <div
                  className={
                    `count-courses-title` +
                    (props.selectedCard === card.id ? " selected" : "") +
                    (card.id === 3 ? " deployed-title" : "") +
                    ` ${textResponsive("text-xs")} font-medium leading-[1.15] uppercase break-words`
                  }
                >
                  {card.title}
                </div>
              </div>
              <img
                src={props.selectedCard === card.id ? card.iconSelected : card.icon}
                alt="Course Icon"
                className="course-icon flex-shrink-0 self-center"
              />
            </Card>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default ViewCourseCount;